// Pro's Video Editor page: the editor area's project list (`features/editor`, `ProjectList`) inside
// Pro's shell; a project opens the editor, full-window, whose ways out return here while the
// remembered UI is Pro (spec ui-perf/ui-switch-classic-simple-pro, PR e6, decision 13). Composed
// here: a feature never imports another; the composition root may.
import { createRoute, useParams } from "@tanstack/react-router";

import { ProjectList } from "../features/editor/ProjectListScreen";
import { ProPage } from "../features/studio2/ProPage";
import { studio2Route } from "../features/studio2/routes";

/** `pro/editor`: the brand's edit projects and "New project". */
export const studio2EditorRoute = createRoute({
  getParentRoute: () => studio2Route,
  path: "editor",
  component: function ProEditor() {
    const { teamId, brandId } = useParams({
      from: "/signed-in/teams/$teamId/brands/$brandId/studio/pro/editor",
    });
    return (
      <ProPage>
        {/* Another brand starts the list anew, as Pro's other pages. */}
        <ProjectList key={`${teamId} ${brandId}`} teamId={teamId} brandId={brandId} />
      </ProPage>
    );
  },
});
